import PendingPatient from './PendingPatient'
export default PendingPatient